/* Tooltip CSS Module */

/* ============================================
   Tooltip Container
   ============================================ */
.tooltipContainer {
  /* Base styles */
  background: var(--colors-components-tooltip-background);
  border: 1px solid var(--colors-border-tertiary);
  border-radius: var(--radii-8);
  box-shadow: var(--shadows-8dp);
  display: inline-block;
  max-width: var(--vapor-tooltip-max-width, 296px);
  overflow-wrap: anywhere;
  padding: var(--spaces-8) var(--spaces-12);
  position: relative;
  text-align: center;
  width: max-content;

  /* Animations */
  opacity: 1;
  transform: scale(1);
  transition-duration: 200ms;
  transition-property: opacity, transform;
  transition-timing-function: var(--transitions-eases-primary);
  visibility: visible;

  &:where(:not([data-position])) {
    visibility: hidden;
    transform: scale(1);
  }

  &:where([data-entering]) {
    transform: scale(0.9);
    opacity: 0;
    visibility: visible;
  }

  &:where([data-exiting]) {
    transition-duration: 100ms;
    transform: scale(1);
    opacity: 0;
  }

  /* Position-based transform origins */
  &:where([data-position='bottom']) {
    transform-origin: 50% 0;
  }

  &:where([data-position='bottom-start']) {
    transform-origin: 0 0;
  }

  &:where([data-position='bottom-end']) {
    transform-origin: 100% 0;
  }

  &:where([data-position='top']) {
    transform-origin: 50% 100%;
  }

  &:where([data-position='top-start']) {
    transform-origin: 0 100%;
  }

  &:where([data-position='top-end']) {
    transform-origin: 100% 100%;
  }

  &:where([data-position='right']) {
    transform-origin: 0 50%;
  }

  &:where([data-position='right-start']) {
    transform-origin: 0 0;
  }

  &:where([data-position='right-end']) {
    transform-origin: 0 100%;
  }

  &:where([data-position='left']) {
    transform-origin: 100% 50%;
  }

  &:where([data-position='left-start']) {
    transform-origin: 100% 0;
  }

  &:where([data-position='left-end']) {
    transform-origin: 100% 100%;
  }
}

/* ============================================
   Tooltip Content Layout
   ============================================ */
.content {
  align-items: center;
  display: flex;
  gap: var(--spaces-12);
}

.adornment {
  flex: 0 0 auto;
}

.textContent {
  flex: 1 1 auto;
  min-width: 0;
}

/* ============================================
   Tooltip Text Styles
   ============================================ */
.tooltipTitle {
  color: var(--colors-text-primary);
  font-family: var(--fonts-body);
  font-size: var(--font-sizes-60);
  font-weight: var(--font-weights-regular);
  line-height: var(--line-heights-50);
  margin: 0;
  min-width: 0;
  overflow-wrap: anywhere;
  white-space: normal;
}

.tooltipDetails {
  color: var(--colors-text-secondary);
  font-family: var(--fonts-body);
  font-size: var(--font-sizes-60);
  font-weight: var(--font-weights-regular);
  line-height: var(--line-heights-50);
  margin: 0;
  overflow-wrap: anywhere;
}

/* ============================================
   Tooltip Title with Shortcut
   ============================================ */
   .titleWithShortcutContainer {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: var(--spaces-8);
    justify-content: flex-start;
    margin-right: calc(var(--spaces-6) * -1);
    text-align: start;
  }

